import { RegionData } from "types"

const getRegionName = (region: RegionData | null): string => {
    if (!region) return "-"
    return region.name || region.country?.name || "-"
}

export const RegionTypeCell = ({ value }: { value: RegionData | null }) => {
    return <span>{getRegionName(value)}</span>
}
